import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';

@Component({
    selector: 'error-block',
    templateUrl: './error-block.component.html',
    styleUrls: ['./error-block.component.css'],
    standalone: false
})
export class ErrorBlockComponent implements OnInit {
  @Output()
  public onClick = new EventEmitter<any>();

  @Input()
  public fieldName?: any = '';

  @Input()
  public message?: any = '';

  @Input()
  public type?: any;

  @Input()
  public code?: any = '';

  @Input()
  public recordIndex?: any = '';

  @Input()
  public columnName?: any = '';

  @Input()
  public panelName?: any = '';

  constructor() {
    // constructor
  }

  public ngOnInit() {
    switch (this.type) {
      case 'TERMINAL':
      case 'PRINTER':
      case 'CERTIFICATE':
      case 'CERTHISTORY':
      case 'SET':
        this.type = 'tpa';
        break;
      default:
        break;
    }
  }

  public onClickMethod() {
    this.onClick.emit({
      recordIndex: this.recordIndex,
      columnName: this.columnName
    });
  }
}
